import React, { forwardRef, Ref } from 'react';
import { MapContainer, TileLayer, Marker, Popup, MapContainerProps } from 'react-leaflet';
import 'leaflet/dist/leaflet.css'; // Importa los estilos CSS de Leaflet
import L from 'leaflet';
import { MenuItem, Select, Typography } from '@mui/material';
import { CheckBox } from '@mui/icons-material';
// Datos de ejemplo con múltiples puntos
const puntos = [
    { id: 1, posicion: [-33.39210, -70.57297], nombre: 'Punto A' },
    { id: 2, posicion: [51.51, -0.1], nombre: 'Punto B' },
    { id: 3, posicion: [51.515, -0.095], nombre: 'Punto C' },
];

const icon = L.icon(
    {
        iconUrl: 'Clinicas/01.png',
        iconSize: [50, 50],

    }
)
const MapaConPuntos = forwardRef((props, ref: Ref<HTMLDivElement>) => {

    /// (clinica, especialidad, cancer)
    /// busqueda clinica - medicos - especialidad
    /// busqueda de cancer - medicos - consultas
    /// especialidad - clinica - medicos
    return (
        <div ref={ref} style={{ backgroundColor: 'rgb(40, 44, 52)' }}>
            <Typography variant='h4' style={{ fontWeight: 600, textAlign: "center", alignSelf: 'center', color: 'white' }} data-aos='zoom-in'>
                Encuentra ayuda especializada
            </Typography>
            <div>
                <MapContainer center={{ lat: -33.5, lng: -70.7 }} zoom={10.0} style={{ minHeight: '500px', marginTop: '1rem' }}>
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    {puntos.map(punto => (
                        <Marker icon={icon} key={punto.id} position={{ lat: punto.posicion[0], lng: punto.posicion[1] }} >
                            <Popup>{punto.nombre}</Popup>
                        </Marker>
                    ))}
                </MapContainer>
            </div>
        </div>
    );
});

export default MapaConPuntos;